module.exports = __webpack_public_path__ + "files/bd65225294e9ad1114ded0a8bde4d38b.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Main-Regular.woff2
// module id = 1661
// module chunks = 60